module.exports = __webpack_public_path__ + "assets/img/banner-cpa-mob.95e64c69.webp";